<!--
 * @Description:客户中心详情
 * @Author: cxh
 * @Date: 2022-09-13 13:33:54
 * @LastEditTime: 2022-10-08 16:16:31
 * @LastEditors: cxh
-->
<template>
  <Fbu v-if="route.query.appId === 'cos_fbu'" :type="type" />
  <Lbu v-if="route.query.appId === 'cos_lbu'" :type="type" />
  <Ofbu v-if="route.query.appId === 'cos_ofbu'" :type="type" />
  <cos-footer-button hideOk />
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { useRoute } from 'vue-router'
import Ofbu from './ofbu.vue'
import Fbu from './fbu.vue'
import Lbu from './lbu.vue'
const type = ref('')
const route = useRoute()
// 跳转详情
const setDetail = () => {
  const { appId } = route.query
  const status = Number(route.query.status as string)
  // 根据状态判断客户阶段10-19 potential 20-29 contract 30-39 clients
  if (status > 9 && status < 20) {
    type.value = 'potential'
  } else if (status > 19 && status < 30) {
    type.value = 'contract'
  } else if (status > 29 && status < 41) {
    type.value = 'clients'
  }
}
onBeforeMount(() => {
  setDetail()
})
</script>
<script lang="ts">
export default { name: 'CustomerAggregationView' }
</script>

<style scoped></style>
